import React, { useState } from "react";
import Card from "components/Card";
import PagingTable from "components/Table/Paging";
import axios from "axios";
import { columns } from "./config";
import _ from "lodash";
import { Column } from "components/Table/Simple";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { staffClient } from "common/apis/staff";
import Checkbox from "components/Form/Checkbox";
import { randomStr } from "components/Utils/ui";
import { toast } from "react-toastify";

const ReviewPage = () => {
    const [refreshKey, setRefreshKey] = useState(_.uniqueId());
    const navigate = useNavigate();
    const fetchData = async (page, limit) => {
        try {
            const params = {
                offset: (page - 1) * limit,
                limit: limit
            }
            // const ret = await axios.get(`https://rest.miview.shop/review`, { params });
            const ret = await staffClient.get("/review", { params });
            const { data, total } = ret.data;
            return {
                data,
                page,
                total
            }
        } catch (e) {
            console.log("[ReviewPage] fetchData error", e);
            return {
                data: null,
                page,
                total: 0
            }
        }
    }

    const postData = async (row) => {
        try {
            // const ret = await axios.post(`https://rest.miview.shop/review`, row);
            const ret = await staffClient.post("/review", row);
            return ret.data;
        } catch (e) {
            console.log("[ReviewPage] postData error", e);
            return null;
        }
    }

    const onCreate = async (row) => {
        console.log("[ReviewPage] onCreate", row);
        const ret = await postData(row);
        if (ret) {
            setRefreshKey(_.uniqueId());
            return true;
        }
    }

    const onDelete = async (row)=>{
        const ok = window.confirm("정말 삭제하시겠습니까?");
        if (!ok) {
            return false;
        }
        try {
            const ret = await staffClient.delete(`/review/${row.id}`);
            console.log("[onDelete] ret", ret);
            toast.success("리뷰가 삭제되었습니다.");
            setRefreshKey(randomStr());
        }catch(e){
            console.error("[onDelete] error", e);
            toast.error("리뷰 삭제 중 오류가 발생했습니다.");
        }
    }

    const onDetailEditClicked = async (row)=>{
        navigate(`/main/review/editor/${row.id}`);
    }

    const handleCheckboxChange = async (row, newChecked)=>{
        console.log("[onCheckboxChange] row", row, newChecked);
        const body = {
            visible: newChecked,
        }
        try {
            const ret = await staffClient.patch(`/review/${row.id}`, body);
            console.log("[onCheckboxChange] ret", ret);
            setRefreshKey(randomStr());
            toast.success(`리뷰 "${row.title}"이 ${newChecked ? "공개" : "비공개"} 상태로 변경되었습니다.`);
            return ret.data;
        } catch (e) {
            console.error("[onCheckboxChange] error", e);
            toast.error("리뷰 정보 수정에 실패했습니다.");
            return null;
        }
    }
    
    const columnsWithActions: Column[] = [
        {
            field: "actions",
            label: "상세수정",
            align: "center",
            render: (value, field, row) => (
                <div className="flex items-center cursor-pointer justify-center" onClick={() => { onDetailEditClicked(row) }}>
                    <PencilSquareIcon className="size-4 align-center"></PencilSquareIcon>
                </div>
            )
        },
        {
            field: "visible",
            label: "공개 여부", 
            render: (value, field, row) => {
                return (
                    <div className="">
                        <Checkbox 
                            checked={value}
                            onChange={(newChecked)=>{handleCheckboxChange(row, newChecked)}}
                        />
                    </div>
                )
            },
        },
        ...columns
    ]

    return (
        <Card>
            <div className="p-3">
                <PagingTable
                    fetchData={fetchData}
                    columns={columnsWithActions}
                    refreshKey={refreshKey}
                    windowSize={100}
                    isCrudable={true}
                    onCreate={onCreate}
                    onDelete={onDelete}
                    isEditable={false}
                />
            </div>
        </Card>
    )
};

export default ReviewPage;

